import React from 'react';

export enum DateInputStyle {
  INPUT,
  LINK,
}

export enum DateInputIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface DateInputProps {
  elementId: string;
  value: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
  label?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  calendarClassName?: string;
  containerClassName?: string;
  showPreviousMonths?: boolean;
  monthsShown?: number;
  autoComplete?: string;
  placeholder?: string;
  dateFormat?: string;
  style?: DateInputStyle;
  popperPlacement?:
    | 'left'
    | 'right'
    | 'top'
    | 'bottom'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'right-start'
    | 'right-end'
    | 'left-start'
    | 'left-end';
  timezone?: string | null;
  icon?: React.JSX.Element;
  iconPosition?: DateInputIconPosition;
  isClearable?: boolean;
  clearIcon?: React.ReactNode;
  clearButtonClassName?: string;
  onChange?: (date: Date | null, event: React.SyntheticEvent<any> | undefined) => void;
  onError?: (err: { code: number; msg: string }) => void;
  onEnterPressed?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
